import Heading from 'components/Heading'
import React from 'react'

import changeLocationButtonNoIamStillIn from './Images/change-location-button-no-i-am-still-in.png'
import changeLocationEditbutton from './Images/change-location-editbutton.png'
import changeLocationEditPortcall from './Images/change-location-edit-portcall.png'
import changeLocationOkButton from './Images/change-location-ok-button.png'
import changeLocationPortAndTerminal from './Images/change-location-port-and-terminal.png'
import changeLocationReflectedimage from './Images/change-location-reflectedimage.png'
import changeLocationUpdatePortAndTerminal from './Images/change-location-updated-port-and-terminal.png'

const ChangeLocationAfterPortcallStart = () => (
  <div>
    <Heading isDark level={2}>
      Change /Update location after starting a port call
    </Heading>

    <p>Follow the below steps to update the location.</p>

    <Heading isDark level={3}>
      Progress screen
    </Heading>
    <img src={changeLocationEditbutton} />
    <p>Press ‘Edit’ button on the top right of the screen.</p>

    <Heading isDark level={3}>
      Edit port call screen
    </Heading>
    <img src={changeLocationEditPortcall} />
    <p>Press ‘Edit port and terminal’ on the screen.</p>

    <Heading isDark level={3}>
      Follow the step if you see a Button on Bottom left ‘No I am still in
      xxxxx’ if not move to next step
    </Heading>
    <img src={changeLocationButtonNoIamStillIn} />
    <p>Click ‘No I am still in xxxxx’</p>

    <Heading isDark level={3}>
      Change port and terminal
    </Heading>
    <img src={changeLocationPortAndTerminal} />
    <p>Enter the new port and terminal.</p>

    <Heading isDark level={3}>
      Update port and terminal
    </Heading>
    <img src={changeLocationOkButton} />
    <p>Update the latest port name and latest terminal name</p>
    <img src={changeLocationUpdatePortAndTerminal} />
    <p>Press ‘ok’ button to confirm the change.</p>

    <Heading isDark level={3}>
      Final result
    </Heading>
    <img src={changeLocationReflectedimage} />
    <p>Under Edit port and terminal new data will be reflected.</p>
  </div>
)

export default ChangeLocationAfterPortcallStart
